// Thin cookie wrapper so components don't poke raw `document.cookie`.
// Site-wide (`path=/`) by default. Used where localStorage is not an
// option (blocked for some clients) and as the single place cookie
// read/write semantics live. Shared by the v5 and bidding bundles.
class CookieStorage {
    get(name) {
        const hit = (document.cookie || '')
            .split('; ')
            .find(c => c.startsWith(name + '='));
        return hit ? hit.slice(name.length + 1) : null;
    }

    has(name) {
        return this.get(name) !== null;
    }

    set(name, value, { days = 30, path = '/' } = {}) {
        const maxAge = days * 24 * 60 * 60;
        document.cookie = `${name}=${value};path=${path};max-age=${maxAge}`;
    }

    remove(name, { path = '/' } = {}) {
        document.cookie = `${name}=;path=${path};max-age=0`;
    }
}

export default new CookieStorage();
